export const Systems = {
    DAISY: 1,
    HPM: 2,
    MINING: 3,
    ALT: 4,
    GOLD: 5,
    BS: 6
  };